export default __webpack_public_path__ + "static/media/illust.df58bba8.png";